module.exports = __webpack_public_path__ + "img/mod_5.8c37aa1e.png";